import React, { useState } from 'react';
import {
  PageWrapper, Container, LogoRow, LogoDot, LogoText,
  Card, Divider, Button, ButtonBack, ModalIcon,
  ModalLabel, InputWrap, Input, ErrorText, TextArea, Title, Subtitle
} from './styles';
import LoadingComponent from '../../components/loading_component';
import { suporteService } from '../../services/suporteService';
import { FaCheckCircle } from 'react-icons/fa';

const FaleConosco = () => {
  const [form, setForm] = useState({ nome: '', email: '', mensagem: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.nome.trim()) e.nome = 'Informe seu nome.';
    if (!form.email.trim()) e.email = 'Informe seu e-mail.';
    if (!form.mensagem.trim()) e.mensagem = 'Descreva sua dúvida ou problema.';
    else if (form.mensagem.length > 10000) e.mensagem = 'Mensagem muito longa (máx. 10.000 caracteres).';
    return e;
  };

  const handleEnviar = async () => {
    const e = validate();
    if (Object.keys(e).length > 0) { setErrors(e); return; }
    setErrors({});
    setLoading(true);

    try {
      const result = await suporteService.enviarMensagem(form.nome, form.email, form.mensagem);

      if (result.ok) {
        setSucesso(true);
        setForm({ nome: '', email: '', mensagem: '' });
        return;
      }

      if (result.kind === 'validation') {
        const d = result.data;
        setErrors({
          nome: d.nome?.[0],
          email: d.email?.[0],
          mensagem: d.mensagem?.[0],
        });
        return;
      }

      if (result.kind === 'rate_limit') {
        setErrors({ geral: 'Muitas tentativas. Aguarde um momento e tente de novo.' });
        return;
      }

      setErrors({ geral: 'Não foi possível enviar. Tente novamente.' });
    } catch {
      setErrors({ geral: 'Não foi possível conectar ao servidor.' });
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;

  if (sucesso) return (
    <PageWrapper>
      <Container>
        <LogoRow>
          <LogoDot />
          <LogoText>VertEcotech</LogoText>
        </LogoRow>

        <Card style={{ textAlign: 'center' }}>
          <ModalIcon style={{ margin: '0 auto 16px' }}>
            <FaCheckCircle />
          </ModalIcon>
          <Title>Mensagem enviada!</Title>
          <Subtitle className="body" style={{ marginTop: '10px' }}>
            Recebemos sua mensagem e nossa equipe entrará em contato o mais breve possível.
          </Subtitle>
          <Divider />
          <Button onClick={() => setSucesso(false)}>Enviar outra mensagem</Button>
        </Card>
      </Container>
    </PageWrapper>
  );

  return (
    <PageWrapper>
      <Container>
        <LogoRow>
          <LogoDot />
          <LogoText>VertEcotech</LogoText>
        </LogoRow>

        <Card>

          <Title>Fale Conosco</Title>
          <Subtitle className="body">
            Envie sua mensagem. Nossa equipe responderá o mais breve possível.
          </Subtitle>

          <Divider />

          <ModalLabel>Nome completo</ModalLabel>
          <InputWrap>
            <Input
              type="text"
              placeholder="Seu nome completo"
              value={form.nome}
              onChange={(e) => setForm({ ...form, nome: e.target.value })}
            />
          </InputWrap>
          {errors.nome && <ErrorText>{errors.nome}</ErrorText>}

          <ModalLabel>E-mail</ModalLabel>
          <InputWrap>
            <Input
              type="email"
              placeholder="seu@email.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </InputWrap>
          {errors.email && <ErrorText>{errors.email}</ErrorText>}

          <ModalLabel>Como podemos ajudar?</ModalLabel>
          <InputWrap>
            <TextArea
              placeholder="Descreva sua dúvida ou problema..."
              value={form.mensagem}
              onChange={(e) => setForm({ ...form, mensagem: e.target.value })}
              maxLength={10000}
            />
          </InputWrap>
          {errors.mensagem && <ErrorText>{errors.mensagem}</ErrorText>}
          {errors.geral && <ErrorText>{errors.geral}</ErrorText>}

          <Divider />
          <Button onClick={handleEnviar} disabled={loading}>
            Enviar mensagem
          </Button>
        </Card>
      </Container>
    </PageWrapper>
  );
};

export default FaleConosco;